import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { NotionIcon, NotionIconBorderless, NotionSearchResultIcon } from './icon';

export const notionConfig: ThirdPartyConfig = {
	displayName: 'Notion',
	id: 'notion',
	resourceType: ProductResourceTypes3P.Notion,
	icon: get3PLogo(NotionIcon, 'Notion', 'medium'),
	iconBorderless: get3PLogo(NotionIconBorderless, 'Notion', 'small'),
	searchResultIcon: get3PLogo(NotionSearchResultIcon, 'Notion', 'large'),
	integrationAri: 'ari:cloud:platform::integration/notion',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
